/*
  ============================================================
  ZENZENA – 11denní výzva: plánovač receptů a nákupní seznam
  (sections/zenzena-vyzva.liquid, assets/zenzena-vyzva.css)
  ------------------------------------------------------------
  Co umí (v2, zjednodušená stránka pro klidné použití):
   - krok 1 „Co budete vařit?“: Celá výzva / Vybrat dny / Vybrat jídla (velká tlačítka),
     „Upřesnit výběr“ schovává typy jídel a přepínač „Jen jídla bez ZENZENA“,
   - krok 2 „Pro kolik osob?“ (1–6, uloženo): násobí množství v seznamu i v receptech,
   - krok 3 nákupní seznam: sečtený po odděleních obchodu, odškrtávání (localStorage),
     „Jdu nakupovat“ (Screen Wake Lock), Produkty ZENZENA v sbaleném bloku,
   - recepty po dnech jako akordeon, karta receptu; video z Instagramu se načte AŽ po
     klepnutí (iframe https://www.instagram.com/<reel|p|tv>/<kód>/embed),
   - export seznamu jako čisté řádky bez značek (Web Share → kopírovat → .txt):
     nativní zaškrtávací seznam web vytvořit neumí, Poznámky ho z vložených řádků
     udělají (Vybrat vše → ikona seznamu), stejně Google Keep (Zobrazit zaškrtávací políčka).

  Data: assets/zz-vyzva-data.json (37 jídel; klíče viz tools v akce-11-11/testy/
  build-vyzva-data.py). Instagram: metaobjekt zz_vyzva_video, sekce ho vypíše
  do <script data-zzv-ig>; spáruje se podle prefixu „Den N · Typ“ (název
  receptu se smí změnit).

  Stav akce: dokud je na <html> třída zz-akce--pred, nic se nenačítá
  (stránka ukazuje jen úvod). Jakmile třída zmizí (start akce, nebo náhled
  ?zz_akce=bezi), plánovač naběhne.

  Mobile first, žádný framework. Vykreslování je jako u předlohy (mockup A):
  celý ovládací blok se překreslí z jednoho modelu, server vykreslil totéž
  pro prázdný výběr, takže při načtení nic neskáče.

  Save as: assets/zenzena-vyzva.js
  ============================================================
*/
(function () {
  'use strict';

  if (window.__zzvScan) { window.__zzvScan(); return; }

  /* ---------- pomocné ---------- */
  var NB = ' ';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var esc = function (s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var cap = function (s) { return s ? s.charAt(0).toUpperCase() + s.slice(1) : s; };
  var pl = function (n, a, b, c) { return n === 1 ? a : (n >= 2 && n <= 4 ? b : c); };
  var clean = function (t) { return String(t || '').replace(/\s*\[OVĚŘIT[^\]]*\]/g, '').trim(); };
  var html = document.documentElement;

  var TYP_LABEL = { snidane: 'Snídaně', obed: 'Oběd', vecere: 'Večeře', vecerni_priprava: 'Večerní příprava', peceni: 'Pečení' };
  var TYP_ICO = { snidane: 'sun', obed: 'bowl', vecere: 'moon', vecerni_priprava: 'clock', peceni: 'oven' };
  var TYP_BY_LABEL = { 'snídaně': 'snidane', 'oběd': 'obed', 'večeře': 'vecere', 'večerní příprava': 'vecerni_priprava', 'pečení': 'peceni' };
  var GRP = [
    { id: 'snidane', chip: 'Snídaně', ico: 'sun' },
    { id: 'obed', chip: 'Obědy', ico: 'bowl' },
    { id: 'vecere', chip: 'Večeře', ico: 'moon' },
    { id: 'priprava', chip: 'Přípravy a pečení', ico: 'clock' }
  ];
  var CATS = [
    { id: 'zelenina-ovoce', label: 'Ovoce, zelenina a mražené', ico: 'apple' },
    { id: 'pecivo', label: 'Pečivo', ico: 'bread' },
    { id: 'maso-ryby', label: 'Maso a ryby', ico: 'fish' },
    { id: 'mlecne', label: 'Mléčné a vejce', ico: 'milk' },
    { id: 'trvanlive', label: 'Trvanlivé', ico: 'jar' },
    { id: 'koreni', label: 'Koření', ico: 'sprig' },
    { id: 'ostatni', label: 'Ostatní', ico: 'bag' }
  ];
  /* krátké názvy příchutí, ze kterých si zákaznice vybírá, když recept říká jen „polévka ZENZENA“ */
  var CAND = { 'polevka-kureci-ryze': 'Kuřecí s rýží', 'polevka-hovezi-nudle': 'Hovězí s nudlemi', 'polevka-minestrone': 'Minestrone', 'polevka-cockova': 'Čočková', 'polevka-dynova': 'Dýňová', 'omeleta-rajcata-syr': 'Se sušenými rajčaty', 'omeleta-bylinky': 'S bylinkami' };

  var P = {
    check: '<path d="M5 12.5l4.5 4.5L19 7.5"/>',
    up: '<path d="M6 15l6-6 6 6"/>', down: '<path d="M6 9l6 6 6-6"/>', right: '<path d="M9 6l6 6-6 6"/>',
    x: '<path d="M6 6l12 12M18 6L6 18"/>', plus: '<path d="M12 5v14M5 12h14"/>', minus: '<path d="M5 12h14"/>',
    list: '<path d="M9 6h11M9 12h11M9 18h11M3.5 6l1 1 2-2M3.5 12l1 1 2-2M3.5 18l1 1 2-2"/>',
    basket: '<path d="M3 9h18l-2 10a2 2 0 0 1-2 1.7H7A2 2 0 0 1 5 19zM8 9l3-5M16 9l-3-5"/>',
    share: '<path d="M12 15V3M8 7l4-4 4 4M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-7"/>',
    copy: '<rect x="8" y="8" width="12" height="12" rx="2"/><path d="M16 8V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2"/>',
    dl: '<path d="M12 4v11M7.5 11 12 15.5 16.5 11M5 20h14"/>',
    play: '<path d="M8 5.5v13l11-6.5z" fill="currentColor" stroke="none"/>',
    cal: '<rect x="3.5" y="5" width="17" height="15" rx="2"/><path d="M3.5 10h17M8 3v4M16 3v4"/>',
    user: '<circle cx="12" cy="8" r="4"/><path d="M4 21c0-4 3.5-7 8-7s8 3 8 7"/>',
    clock: '<circle cx="12" cy="13" r="8"/><path d="M12 9v4.5l3 1.5M9.5 2.5h5"/>',
    sun: '<circle cx="12" cy="12" r="4"/><path d="M12 2.5v2.5M12 19v2.5M4.6 4.6l1.8 1.8M17.6 17.6l1.8 1.8M2.5 12H5M19 12h2.5M4.6 19.4l1.8-1.8M17.6 6.4l1.8-1.8"/>',
    bowl: '<path d="M3 12h18a9 9 0 0 1-18 0zM8 8c0-1.6 1-2 1-3.5M12 8c0-1.6 1-2 1-3.5M16 8c0-1.6 1-2 1-3.5"/>',
    moon: '<path d="M20 14.5A8.5 8.5 0 1 1 9.5 4a7 7 0 0 0 10.5 10.5z"/>',
    oven: '<rect x="3" y="4" width="18" height="16" rx="2"/><path d="M3 9h18M7 6.5h.01M10 6.5h.01"/><rect x="6.5" y="12" width="11" height="5" rx="1"/>',
    leaf: '<path d="M5 19c0-8 5-13 14-14 0 9-5 14-13 14M5 19c3-5 6-8 10-10"/>',
    apple: '<path d="M12 7.5c-3-2-8-1-8 5 0 5 3 8.5 5.5 8.5 1.2 0 1.7-.7 2.5-.7s1.3.7 2.5.7c2.5 0 5.5-3.5 5.5-8.5 0-6-5-7-8-5zM12 7.5c0-2 1-3.5 3-4.5"/>',
    bread: '<path d="M5 11c0-3.5 3-6 7-6s7 2.5 7 6c0 1-.5 1.7-1 2v5.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 6 18.5V13c-.5-.3-1-1-1-2z"/>',
    fish: '<path d="M3 12c2.5-4 6-5.5 10-4 1.5.6 3 1.7 4 3l3.5-3v8L17 13c-1 1.3-2.5 2.4-4 3-4 1.5-7.5 0-10-4z"/><path d="M8.5 11.5v.01"/>',
    milk: '<path d="M9 2.5h6M10 2.5v4l-3 4V20a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V10.5l-3-4v-4M7 14h10"/>',
    jar: '<rect x="5" y="8" width="14" height="13" rx="3"/><path d="M6.5 8V5h11v3M9 14h6"/>',
    sprig: '<path d="M12 21V9"/><path d="M12 14c-4 0-6-2-6-5 4 0 6 2 6 5zM12 11c4 0 6-2 6-5-4 0-6 2-6 5z"/>',
    bag: '<path d="M5 8h14l-1 12.5H6zM9 8V6.5a3 3 0 0 1 6 0V8"/>',
    box: '<path d="M3 8l9-5 9 5v8l-9 5-9-5zM3 8l9 5 9-5M12 13v8"/>',
    bulb: '<path d="M9 18h6M10 21h4M12 3a6 6 0 0 0-3.5 10.9c.6.5 1 1.2 1 2.1h5c0-.9.4-1.6 1-2.1A6 6 0 0 0 12 3z"/>'
  };
  var ic = function (n, s) {
    s = s || 20;
    return '<svg width="' + s + '" height="' + s + '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' + (P[n] || '') + '</svg>';
  };

  /* ---------- typografie: nezlomitelná mezera za jednopísmennými předložkami a před jednotkami ---------- */
  function fixNbsp(root) {
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) { return /^(SCRIPT|STYLE|TEXTAREA)$/.test(n.parentNode.nodeName) ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT; }
    });
    var list = [];
    while (w.nextNode()) list.push(w.currentNode);
    list.forEach(function (n) {
      var t = n.nodeValue; if (!t || !/\s/.test(t)) return;
      var o = t;
      t = t.replace(/(^|[\s(„])([ksvzouiaKSVZOUIA])\s+(?=\S)/g, '$1$2' + NB).replace(/(^|[\s(„])([ksvzouiaKSVZOUIA])\s+(?=\S)/g, '$1$2' + NB);
      t = t.replace(/(\d)\s+(?=(?:g|kg|ml|l|ks|min|minut|minuty|minutu|Kč|porce|porcí|porci|položek|položky|položka|jídel|jídla|jídlo|lžička|lžičky|lžiček|lžíce|lžic|plechovky|plechovek|plechovka|stroužky|stroužků|stroužek|odměrka|odměrky|odměrek|hotovo|muffinů)(?![A-Za-zÀ-ž]))/g, '$1' + NB);
      t = t.replace(/\b(Den|Dny|dny|den)\s+(?=\d)/g, '$1' + NB);
      if (t !== o) n.nodeValue = t;
    });
  }

  /* ---------- množství a součty ---------- */
  function fmtNum(n) {
    var fr = { 0.25: '¼', 0.5: '½', 0.75: '¾' };
    n = Math.round(n * 100) / 100;
    var w = Math.floor(n + 1e-9), f = Math.round((n - w) * 100) / 100;
    if (f === 0) return String(w);
    if (fr[f]) return (w ? String(w) : '') + fr[f];
    return String(n).replace('.', ',');
  }
  var FORMS = { 'lžička': ['lžička', 'lžičky', 'lžiček'], 'lžíce': ['lžíce', 'lžíce', 'lžic'], 'plechovka': ['plechovka', 'plechovky', 'plechovek'], 'stroužek': ['stroužek', 'stroužky', 'stroužků'], 'odměrka': ['odměrka', 'odměrky', 'odměrek'] };
  function fmtQty(n, u) {
    if (u === 'g' && n >= 1000) return fmtNum(n / 1000) + ' kg';
    if (u === 'ml' && n >= 1000) return fmtNum(n / 1000) + ' l';
    if (!u || u === 'ks' || u === 'g' || u === 'ml') return fmtNum(n) + ' ' + (u || 'ks');
    var f = FORMS[u];
    if (!f) return fmtNum(n) + ' ' + u;
    var frac = Math.abs(n - Math.round(n)) > 1e-9;
    var form = frac ? f[1] : (n === 1 ? f[0] : (n >= 2 && n <= 4 ? f[1] : f[2]));
    return fmtNum(n) + ' ' + form;
  }
  function qual(ing) {
    var t = clean(ing.puvodni_text), n = ing.nazev;
    if (t.toLowerCase().indexOf(n.toLowerCase()) === 0) t = t.slice(n.length); else return '';
    return t.replace(/^[\s,]+/, '').trim();
  }
  function ranges(arr) {
    arr = arr.slice().sort(function (a, b) { return a - b; });
    var out = [], i = 0;
    while (i < arr.length) {
      var j = i;
      while (j + 1 < arr.length && arr[j + 1] === arr[j] + 1) j++;
      if (j - i >= 2) out.push(arr[i] + '–' + arr[j]); else for (var k = i; k <= j; k++) out.push(arr[k]);
      i = j + 1;
    }
    return out.join(', ');
  }
  var daysLabel = function (set) { var a = Array.from(set); return a.length ? (a.length === 1 ? 'den ' : 'dny ') + ranges(a) : ''; };
  var nMeals = function (n) { return n + ' ' + pl(n, 'jídlo', 'jídla', 'jídel'); };
  var nItems = function (n) { return n + ' ' + pl(n, 'položka', 'položky', 'položek'); };

  /* ============================================================
     Jedna instance stránky
     ============================================================ */
  function boot(root) {
    var cfg = {};
    try { cfg = JSON.parse($('[data-zzv-cfg]', root).textContent); } catch (e) { cfg = {}; }
    var T = Object.assign({
      step1: 'Co budete vařit?',
      step2: 'Pro kolik osob nakupujete?',
      step3: 'Nákupní seznam',
      step3Btn: 'Zobrazit nákupní seznam',
      hintDny: 'Klepněte na dny, které budete vařit. Můžete jich vybrat víc.',
      hintJidla: 'Níže otevřete den a u jídel, která chcete vařit, klepněte na „Přidat do nákupu“.',
      recipes: 'Recepty',
      recipesHint: 'Klepněte na den a uvidíte jídla. Recept s postupem otevřete tlačítkem „Recept“.',
      listTitle: 'Nákupní seznam',
      shareHint: 'V Poznámkách označte celý text a klepněte na ikonu seznamu s kroužkem nad klávesnicí, každý řádek dostane zaškrtávací kolečko. V Google Keep: tři tečky → Zobrazit zaškrtávací políčka.',
      zenTitle: 'Produkty ZENZENA',
      zenText: 'Tyhle kousky nekoupíte v obchodě. Objednejte je na zenzena.cz.',
      homeTitle: 'Už máte doma z předchozích dní'
    }, cfg.t || {});
    var IMG = cfg.img || {};
    var SHOP = '';                 /* odkazy na produkty jsou relativní: /products/<handle> */
    var ORIGIN = location.origin;  /* do exportu textu patří celá adresa */
    var app = $('[data-zzv-app]', root);
    var ov = $('[data-zzv-ov]', root);
    var shopEl = $('[data-zzv-shop]', root);
    var toastEl = $('[data-zzv-toast]', root);
    var inner = $('.zzv-in', root);

    function fail(msg) {
      app.innerHTML = '<div class="zzv-empty" role="alert"><b>' + esc(msg) + '</b><button type="button" class="zzv-btn zzv-btn--sec zzv-btn--sm" data-act="retry">Zkusit znovu</button></div>';
    }
    /* Server ve stavu „před startem“ adresu dat do HTML nevypisuje (stránka ji před startem neprozradí).
       Když se stránka z keše nebo z náhledu ?zz_akce= přesto spouští, adresa se odvodí z CSS sekce
       – leží ve stejné složce motivu. */
    function dataUrl() {
      if (cfg.dataUrl) return cfg.dataUrl;
      var l = $$('link[rel=stylesheet]').filter(function (x) { return /zenzena-vyzva\.css/.test(x.href); })[0];
      return l ? l.href.replace(/zenzena-vyzva\.css.*$/, 'zz-vyzva-data.json') : '';
    }
    /* Odkazy na videa server před startem také nevypisuje (data-pred). Po startu se jednou stáhne
       čerstvé HTML stránky a vezmou se odtud. */
    var igNode = $('[data-zzv-ig]', root);
    if (igNode && igNode.getAttribute('data-pred') === '1') {
      fetch(location.pathname + '?zzv=' + Date.now(), { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (t) {
          var n = new DOMParser().parseFromString(t, 'text/html').querySelector('[data-zzv-ig]');
          if (n && n.getAttribute('data-pred') !== '1') { igNode.textContent = n.textContent; igNode.removeAttribute('data-pred'); }
        })
        .catch(function () { /* videa se ukážou po dalším načtení */ });
    }
    function load() {
      fetch(dataUrl(), { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
        .then(function (data) { run(data); })
        .catch(function () {
          fail('Recepty se nepodařilo načíst.');
          app.addEventListener('click', function retry(e) {
            if (!e.target.closest('[data-act=retry]')) return;
            app.removeEventListener('click', retry);
            load();
          });
        });
    }
    load();

    function run(DATA) {
      var DAYS = Array.from(new Set(DATA.map(function (m) { return m.den; }))).sort(function (a, b) { return a - b; });
      var byId = new Map(DATA.map(function (m) { return [m.id, m]; }));
      var mealsOf = function (d) { return DATA.filter(function (m) { return m.den === d; }); };
      var grp = function (m) { return (m.typ === 'snidane' || m.typ === 'obed' || m.typ === 'vecere') ? m.typ : 'priprava'; };
      var hasZen = function (m) { return !!(m.zenzena_produkt || m.ingredience.some(function (g) { return g.kategorie_obchodu === 'zenzena'; })); };

      /* ---------- stav ---------- */
      var KEY = 'zz-vyzva-v1';
      var sel = new Set(), chk = new Set();
      var persons = 1;   /* pro kolik osob se nakupuje (1–6); data receptů jsou pro 1 osobu */
      var noZen = false; /* „Jen jídla bez ZENZENA“ */
      var ui = { panel: null, adv: false, zenOpen: false, open: new Set(), vid: new Set(), sheet: null, fresh: false, shopping: false, wl: 'idle', lastFocus: null };
      try {
        var o = JSON.parse(localStorage.getItem(KEY) || '{}');
        (o.sel || []).forEach(function (id) { if (byId.has(id)) sel.add(id); });
        (o.chk || []).forEach(function (k) { chk.add(k); });
        if (o.persons >= 1 && o.persons <= 6) persons = Math.round(o.persons);
        noZen = o.noZen === true;
      } catch (e) { /* soukromý režim nebo poškozený klíč */ }
      var canSel = function (m) { return !noZen || !hasZen(m); };
      if (noZen) DATA.forEach(function (m) { if (!canSel(m)) sel.delete(m.id); });
      function persist() {
        try { localStorage.setItem(KEY, JSON.stringify({ sel: Array.from(sel), chk: Array.from(chk), persons: persons, noZen: noZen })); } catch (e) { /* nic */ }
      }

      /* ---------- výběr: jedna množina jídel, ovladače jsou zkratky ---------- */
      function dayState(d) {
        var ms = mealsOf(d).filter(canSel); if (!ms.length) return 0;
        var n = ms.filter(function (m) { return sel.has(m.id); }).length; return n === 0 ? 0 : (n === ms.length ? 2 : 1);
      }
      function toggleDay(d) {
        var ms = mealsOf(d).filter(canSel);
        if (dayState(d) === 2) ms.forEach(function (m) { sel.delete(m.id); }); else ms.forEach(function (m) { sel.add(m.id); });
      }
      function selDays() { return new Set(DATA.filter(function (m) { return sel.has(m.id); }).map(function (m) { return m.den; })); }
      /* typ se přepíná v „rozsahu“ = dny, které už mají něco vybráno (nic vybráno = celá výzva) */
      function scopeDays() { var s = selDays(); return s.size ? s : new Set(DAYS); }
      function typeTargets(t) { var sd = scopeDays(); return DATA.filter(function (m) { return grp(m) === t && sd.has(m.den) && canSel(m); }); }
      function typeState(t) { var T2 = typeTargets(t); var n = T2.filter(function (m) { return sel.has(m.id); }).length; return n === 0 ? 0 : (n === T2.length ? 2 : 1); }
      function toggleType(t) { var T2 = typeTargets(t); if (typeState(t) === 2) T2.forEach(function (m) { sel.delete(m.id); }); else T2.forEach(function (m) { sel.add(m.id); }); }
      function setDays(arr) { sel.clear(); chk.clear(); arr.forEach(function (d) { mealsOf(d).filter(canSel).forEach(function (m) { sel.add(m.id); }); }); }
      function allSelected() { var s = DATA.filter(canSel); return s.length > 0 && s.every(function (m) { return sel.has(m.id); }); }
      function toggleAll() {
        chk.clear();
        if (allSelected()) sel.clear(); else DATA.filter(canSel).forEach(function (m) { sel.add(m.id); });
      }

      /* ---------- pro kolik osob: násobení množství ----------
         Data jsou pro 1 osobu, pečení (jedna dávka muffinů) se nenásobí. Zaokrouhlení jen při
         více osobách: g a ml na celé nahoru, ks a podobné na půlku nahoru, lžíce a lžičky na čtvrtku. */
      var factor = function (m) { return m.porce == null ? 1 : persons; };
      function roundQty(n, u) {
        if (persons === 1) return n;
        if (u === 'g' || u === 'ml') return Math.ceil(n - 1e-9);
        if (u === 'kg' || u === 'l') return Math.round(n * 100) / 100;
        if (u === 'lžička' || u === 'lžíce') return Math.round(n * 4) / 4;
        return Math.ceil(n * 2 - 1e-9) / 2;
      }
      var UNIT_LEMMA = { 'lžička': 'lžička', 'lžičky': 'lžička', 'lžiček': 'lžička', 'lžíce': 'lžíce', 'lžic': 'lžíce', 'krajíce': 'krajíc', 'krajíc': 'krajíc', 'stroužek': 'stroužek', 'stroužky': 'stroužek', 'stroužků': 'stroužek', 'odměrka': 'odměrka', 'odměrky': 'odměrka', 'odměrek': 'odměrka', 'plechovka': 'plechovka', 'plechovky': 'plechovka', 'plechovek': 'plechovka', 'hrnek': 'hrnek', 'hrnky': 'hrnek', 'hrnků': 'hrnek', 'menší': 'menší', 'velký': 'velký', 'g': 'g', 'kg': 'kg', 'ml': 'ml', 'l': 'l', 'ks': 'ks' };
      var FORMS2 = { 'krajíc': ['krajíc', 'krajíce', 'krajíců'], 'hrnek': ['hrnek', 'hrnky', 'hrnků'], 'menší': ['menší', 'menší', 'menších'], 'velký': ['velký', 'velké', 'velkých'] };
      var QTY_RE = /(\d+(?:,\d+)?\s*[¼½¾]|\d+(?:,\d+)?|[¼½¾])\s*(g|kg|ml|l|ks|lžíce|lžička|lžičky|lžiček|lžic|krajíce|krajíc|stroužek|stroužky|stroužků|odměrka|odměrky|odměrek|plechovka|plechovky|plechovek|hrnek|hrnky|hrnků|menší|velký)(?![A-Za-zÀ-ž])/g;
      function parseQty(s) {
        var fr = { '¼': 0.25, '½': 0.5, '¾': 0.75 };
        s = s.replace(/\s+/g, '');
        var m = /^(\d+(?:,\d+)?)?([¼½¾])?$/.exec(s); if (!m) return NaN;
        return (m[1] ? parseFloat(m[1].replace(',', '.')) : 0) + (m[2] ? fr[m[2]] : 0);
      }
      function unitText(lemma, n) {
        var f = FORMS[lemma] || FORMS2[lemma];
        if (!f) return lemma;
        var frac = Math.abs(n - Math.round(n)) > 1e-9;
        return frac ? f[1] : (n === 1 ? f[0] : (n >= 2 && n <= 4 ? f[1] : f[2]));
      }
      /* text suroviny z receptu („med 7 g (1 lžička)“) pro více osob: každé množství s jednotkou se přenásobí */
      function scaleText(t) {
        if (persons === 1) return t;
        return t.replace(QTY_RE, function (all, num, unit) {
          var v = parseQty(num); if (isNaN(v)) return all;
          var lemma = UNIT_LEMMA[unit] || unit;
          var n = roundQty(v * persons, lemma);
          return fmtNum(n) + (lemma === 'g' || lemma === 'ml' || lemma === 'ks' || lemma === 'kg' || lemma === 'l' ? ' ' + lemma : ' ' + unitText(lemma, n));
        });
      }

      /* ---------- nákupní seznam ze zadaných jídel ----------
         stejný název + jednotka se sečte, různé jednotky se spojí „+“,
         položky bez množství jsou „podle chuti“ / původní upřesnění,
         „nenakupovat“ jde zvlášť do „Už máte doma“, ZENZENA zvlášť s odkazem. */
      function buildList(ids) {
        var meals = DATA.filter(function (m) { return ids.has(m.id); });
        var items = new Map(), zen = new Map(), home = [];
        /* Zbytek z dřívějšího jídla („Už máte doma“): data říkají jen z JAKÉHO DNE, ne z jakého jídla.
           Zdroj = večeře a večerní přípravy toho dne (kromě jídla, které zbytek spotřebuje);
           když žádné nejsou (pečené batáty dne 8 zbydou z oběda), jídla toho dne kromě snídaně.
           Varování, dokud nejsou všechna zdrojová jídla ve výběru: jinak by seznam tvrdil „máte doma“
           a nikde by nebylo, co koupit. */
        var zdrojeZbytku = function (m, g) {
          var ms = mealsOf(g.odkaz_den).filter(function (x) { return x.id !== m.id; });
          var src = ms.filter(function (x) { return x.typ === 'vecere' || x.typ === 'vecerni_priprava'; });
          return src.length ? src : ms.filter(function (x) { return x.typ !== 'snidane'; });
        };
        meals.forEach(function (m) {
          var f = factor(m);
          m.ingredience.forEach(function (g) {
            if (g.nenakupovat) {
              if (g.odkaz_den != null) home.push({ name: cap(g.nazev), amt: g.mnozstvi != null ? fmtQty(roundQty(g.mnozstvi * f, g.jednotka), g.jednotka) : '', den: g.odkaz_den, warn: !zdrojeZbytku(m, g).every(function (x) { return ids.has(x.id); }) });
              return;
            }
            if (g.kategorie_obchodu === 'zenzena') {
              var zk = g.zenzena_produkt || g.nazev;
              var z = zen.get(zk);
              if (!z) { z = { key: zk, name: cap(g.nazev), handle: g.zenzena_produkt || null, cand: g.zenzena_kandidati || [], n: 0, days: new Set() }; zen.set(zk, z); }
              z.n += (g.mnozstvi || 1) * f; z.days.add(m.den);
              return;
            }
            var key = g.nazev;
            var it = items.get(key);
            if (!it) { it = { key: key, name: cap(g.nazev), cat: g.kategorie_obchodu, parts: new Map(), q: new Set(), nulls: 0, days: new Set() }; items.set(key, it); }
            if (g.mnozstvi == null) { it.nulls++; it.q.add(qual(g) || 'podle chuti'); }
            else it.parts.set(g.jednotka, (it.parts.get(g.jednotka) || 0) + g.mnozstvi * f);
            it.days.add(m.den);
          });
        });
        items.forEach(function (it) {
          var a = Array.from(it.parts).map(function (p) { return fmtQty(roundQty(p[1], p[0]), p[0]); });
          var t = a.join(' + ');
          if (it.nulls) { var q = Array.from(it.q).join(', '); t = t ? t + ' + ' + q : q; }
          it.amt = t;
          /* odškrtnutí platí jen pro tuhle surovinu v tomhle množství (změna výběru množství odškrtnutí zruší) */
          it.ck = it.key + '|' + t;
        });
        zen.forEach(function (z) { if (persons > 1) z.n = Math.ceil(z.n - 1e-9); z.ck = 'z:' + z.key + '|' + z.n; });
        var iv = Array.from(items.values());
        var cats = CATS.map(function (c) {
          return Object.assign({}, c, { items: iv.filter(function (i) { return i.cat === c.id; }).sort(function (a, b) { return a.name.localeCompare(b.name, 'cs'); }) });
        }).filter(function (c) { return c.items.length; });
        var zl = Array.from(zen.values()).sort(function (a, b) { return a.name.localeCompare(b.name, 'cs'); });
        var count = iv.length + zl.length;
        var done = iv.filter(function (i) { return chk.has(i.ck); }).length + zl.filter(function (z) { return chk.has(z.ck); }).length;
        return { cats: cats, zen: zl, home: home, count: count, done: done, meals: meals };
      }
      var personsText = function () { return persons + ' ' + pl(persons, 'osoba', 'osoby', 'osob'); };
      function selSummary() {
        var n = sel.size; if (!n) return 'nic nevybráno';
        if (allSelected()) return 'celá výzva · ' + nMeals(n);
        return nMeals(n) + ' · ' + daysLabel(selDays());
      }

      /* ---------- export textu (Poznámky / Keep / Připomínky) ----------
         Čisté řádky bez znaků „◻︎“: web nemůže vytvořit nativní zaškrtávací seznam, ale prostý text po řádcích
         si Poznámky (Vybrat vše → ikona seznamu), Google Keep (Zobrazit zaškrtávací políčka) i Připomínky umí převzít.
         První řádek je název, Poznámky z něj dělají nadpis poznámky. */
      function exportText() {
        var L = buildList(sel), out = [];
        out.push('Nákupní seznam – 11denní výzva' + (persons > 1 ? ' (' + personsText() + ')' : ''));
        var zl = L.zen.filter(function (z) { return !chk.has(z.ck); });
        if (zl.length) {
          out.push('PRODUKTY ZENZENA');
          zl.forEach(function (z) {
            var u = z.handle ? ORIGIN + '/products/' + z.handle : (z.cand.length === 1 ? ORIGIN + '/products/' + z.cand[0] : '');
            out.push(zShort(z.name) + ' – ' + z.n + ' ks' + (u ? ' – ' + u : (z.cand.length ? ' – příchuť vyberte na zenzena.cz' : '')));
          });
        }
        L.cats.forEach(function (c) {
          var its = c.items.filter(function (i) { return !chk.has(i.ck); });
          if (!its.length) return;
          out.push(c.label.toUpperCase());
          its.forEach(function (i) { out.push(i.name + ' – ' + i.amt); });
        });
        return out.join('\n') + '\n';
      }
      var toastT = 0;
      function toast(t) { toastEl.textContent = t; toastEl.classList.add('is-on'); clearTimeout(toastT); toastT = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2600); }
      async function doCopy(text, msg) {
        try { await navigator.clipboard.writeText(text); toast(msg || 'Seznam je zkopírovaný.'); return true; } catch (e) { /* náhrada níž */ }
        try {
          var ta = document.createElement('textarea'); ta.value = text; ta.setAttribute('readonly', '');
          ta.style.cssText = 'position:fixed;top:0;left:0;opacity:0'; document.body.appendChild(ta);
          ta.select(); ta.setSelectionRange(0, 99999);
          var ok = document.execCommand('copy'); ta.remove();
          if (ok) { toast(msg || 'Seznam je zkopírovaný.'); return true; }
        } catch (e) { /* nic */ }
        toast('Kopírování se nepovedlo. Zkuste „Stáhnout .txt“.'); return false;
      }
      async function doShare() {
        var text = exportText();
        if (navigator.share) {
          try { await navigator.share({ title: 'Nákupní seznam – 11denní výzva', text: text }); return; }
          catch (e) { if (e && e.name === 'AbortError') return; }
        }
        await doCopy(text, 'Sdílení tu není. Seznam je zkopírovaný, vložte ho do Poznámek.');
      }
      function doDownload() {
        var blob = new Blob([exportText()], { type: 'text/plain;charset=utf-8' });
        var a = document.createElement('a'); a.href = URL.createObjectURL(blob); a.download = 'nakupni-seznam-vyzva.txt';
        document.body.appendChild(a); a.click(); a.remove(); setTimeout(function () { URL.revokeObjectURL(a.href); }, 1500);
        toast('Soubor nakupni-seznam-vyzva.txt se stahuje.');
      }

      /* ---------- Screen Wake Lock + náhrada, když API chybí ----------
         wlSeq: každé vyžádání a každé uvolnění ho zvýší. Zámek, který prohlížeč vydá
         až po „Hotovo“ (nebo po novějším vyžádání), se hned uvolní, jinak by displej
         svítil dál, i když režim nákupu už je zavřený. */
      var wlock = null, wlSeq = 0;
      async function wlOn() {
        var my = ++wlSeq;
        if (!('wakeLock' in navigator) || !navigator.wakeLock) { ui.wl = 'unsupported'; return; }
        try {
          var l = await navigator.wakeLock.request('screen');
          if (my !== wlSeq || !ui.shopping) { try { await l.release(); } catch (e) { /* nic */ } return; }
          wlock = l; ui.wl = 'on';
          l.addEventListener('release', function () { if (wlock === l) { wlock = null; if (ui.shopping) { ui.wl = 'off'; renderShop(); } } });
        } catch (e) { ui.wl = 'denied'; }
      }
      async function wlOff() { wlSeq++; try { if (wlock) await wlock.release(); } catch (e) { /* nic */ } wlock = null; ui.wl = 'idle'; }
      document.addEventListener('visibilitychange', async function () {
        if (!root.isConnected) return;
        if (document.visibilityState === 'visible' && ui.shopping && !wlock) { await wlOn(); if (ui.shopping) renderShop(); }
      });
      async function startShopping() {
        rememberFocus(); ui.shopping = true; closeSheet(true); lock(true);
        renderShop();                       /* režim se ukáže hned, i když prohlížeč s Wake Lockem váhá nebo ho odmítne */
        var b = $('[data-act=shopx]', shopEl); if (b) b.focus();
        await wlOn();
        if (ui.shopping) renderShop();
      }
      async function stopShopping() { ui.shopping = false; await wlOff(); renderShop(); lock(!!ui.sheet); update(); restoreFocus(); }

      /* ---------- instagram: spárování podle „Den N · Typ“ ---------- */
      function igFor(m) {
        var arr = [];
        try { arr = JSON.parse(($('[data-zzv-ig]', root) || {}).textContent || '[]'); } catch (e) { arr = []; }
        for (var i = 0; i < arr.length; i++) {
          var r = String(arr[i].r || ''), u = String(arr[i].u || '');
          /* oddělovač je „·“, ale snese i tečku jinde z Unicode, odrážku, svislítko nebo pomlčku */
          var k = /^\s*Den\s+(\d+)\s*[·•⋅∙|–—-]\s*([^·•⋅∙|–—-]+?)\s*(?:[·•⋅∙|–—-]|$)/i.exec(r);
          if (!k || +k[1] !== m.den || TYP_BY_LABEL[k[2].toLowerCase()] !== m.typ) continue;
          var p = /^https?:\/\/(?:www\.)?instagram\.com\/(reels?|p|tv)\/([A-Za-z0-9_-]+)/i.exec(u);
          if (!p) continue;
          var kind = p[1].toLowerCase(); if (kind === 'reels') kind = 'reel';
          return 'https://www.instagram.com/' + kind + '/' + p[2] + '/embed';
        }
        return '';
      }

      /* ---------- stavební bloky ---------- */
      var porceText = function (m) { return m.porce ? (m.porce * persons) + ' ' + pl(m.porce * persons, 'porce', 'porce', 'porcí') : (m.porce_text || ''); };
      var casShort = function (m) { return (m.cas || '').split(',')[0]; };
      var tgl = function (m) {
        if (!canSel(m)) return '<span class="zzv-tgl zzv-tgl--off"><span>Obsahuje ZENZENA</span></span>';
        return '<label class="zzv-tgl"><input type="checkbox" data-act="meal" data-id="' + m.id + '"' + (sel.has(m.id) ? ' checked' : '') + '><span><b class="off">' + ic('plus', 18) + 'Přidat do nákupu</b><b class="on">' + ic('check', 18) + 'V nákupu</b></span></label>';
      };
      function card(m) {
        return '<article class="zzv-mc" id="zzv-m-' + m.id + '">' +
          '<h4 class="zzv-mc__t"><button type="button" data-act="recipe" data-id="' + m.id + '">' + esc(m.nazev) + '</button></h4>' +
          '<p class="zzv-mc__m">' + TYP_LABEL[m.typ] + ' · ' + esc(porceText(m)) + ' · ' + esc(casShort(m)) + (hasZen(m) ? ' · <b class="zzv-zenmark">ZENZENA</b>' : '') + '</p>' +
          '<div class="zzv-mc__a">' + tgl(m) + '<button type="button" class="zzv-btn zzv-btn--sec zzv-btn--sm" data-act="recipe" data-id="' + m.id + '">Recept</button></div>' +
          '</article>';
      }

      /* ---------- recept ---------- */
      function vid(m) {
        var u = igFor(m);
        if (!u) return '';
        if (!ui.vid.has(m.id)) {
          return '<div class="zzv-vid"><div class="zzv-vid__f" role="img" aria-label="Zástupný rámeček videa 9:16"><span class="pl">' + ic('play', 30) + '</span><b>Video na Instagramu</b><small>Reel k tomuhle receptu</small></div>' +
            '<button type="button" class="zzv-btn zzv-btn--sm" data-act="vid" data-id="' + m.id + '">' + ic('play', 16) + 'Přehrát video</button>' +
            '<p class="zzv-vid__n">Video se načte až po klepnutí, ať stránka zůstane rychlá.</p></div>';
        }
        return '<div class="zzv-vid"><div class="zzv-vid__f zzv-vid__f--on"><iframe src="' + esc(u) + '" title="Instagram reel: ' + esc(m.nazev) + '" loading="lazy" allow="encrypted-media; picture-in-picture" allowfullscreen referrerpolicy="strict-origin-when-cross-origin"></iframe></div></div>';
      }
      function splitIng(g) {
        var t = clean(g.puvodni_text), n = g.nazev;
        if (t.toLowerCase().indexOf(n.toLowerCase()) === 0) return [cap(n), t.slice(n.length).replace(/^[\s,]+/, '')];
        return [cap(t), ''];
      }
      function ingList(m) {
        var h = '', cur = null;
        var scale = m.porce != null;
        m.ingredience.forEach(function (g) {
          var k = g.skupina || '';
          if (k !== cur) { if (k) h += '<li class="h5"><h5>' + esc(cap(k)) + '</h5></li>'; cur = k; }
          var sp = splitIng(g), skip = g.nenakupovat;
          var tag = skip ? (g.odkaz_den != null ? '<span class="tg">máte doma, ze dne ' + g.odkaz_den + '</span>' : '<span class="tg">z kohoutku</span>') : '';
          h += '<li' + (skip ? ' class="skip"' : '') + '><span>' + esc(sp[0]) + tag + '</span><span>' + esc(scale ? scaleText(sp[1]) : sp[1]) + '</span></li>';
        });
        return h;
      }
      function zenCall(m) {
        var zs = m.ingredience.filter(function (g) { return g.kategorie_obchodu === 'zenzena'; });
        return zs.map(function (g) {
          var h = g.zenzena_produkt || (g.zenzena_kandidati && g.zenzena_kandidati.length === 1 ? g.zenzena_kandidati[0] : null);
          var img = g.zenzena_produkt && IMG[g.zenzena_produkt];
          var alt = !g.zenzena_produkt && g.zenzena_kandidati && g.zenzena_kandidati.length > 1;
          return '<div class="zzv-zcall"><div class="zzv-zcall__r">' +
            (img ? '<img class="zzv-thumb" src="' + esc(img) + '" alt="" width="44" height="44" loading="lazy">' : '<span class="zzv-thumb zzv-thumb--e">' + ic('leaf', 22) + '</span>') +
            '<div class="zzv-zcall__t">' + esc(cap(clean(g.nazev))) + '<small>' + (g.zenzena_produkt ? 'Příprava podle návodu na obalu' : (alt ? 'Vyberte příchuť' : 'Nejbližší v nabídce: ' + esc(CAND[h] || ''))) + '</small></div>' +
            (h ? '<a class="zzv-btn zzv-btn--sec zzv-btn--sm" href="' + SHOP + '/products/' + h + '" target="_blank" rel="noopener">Koupit</a>' : '') + '</div>' +
            (alt ? '<div class="zzv-zr__alt" style="padding:0">' + g.zenzena_kandidati.map(function (c) { return '<a href="' + SHOP + '/products/' + c + '" target="_blank" rel="noopener">' + esc(CAND[c] || c) + '</a>'; }).join('') + '</div>' : '') +
            '</div>';
        }).join('');
      }
      function recipeBody(m, o2) {
        o2 = o2 || {};
        return '<div class="zzv-rc">' +
          '<p class="zzv-rc__meta">' + esc(porceText(m)) + ' · ' + esc(m.cas || '') + '</p>' +
          (m.poznamka ? '<p class="zzv-tip">' + esc(m.poznamka) + '</p>' : '') + zenCall(m) +
          vid(m) +
          '<div><h4>Suroviny' + (persons > 1 && m.porce != null ? ' pro ' + personsText() : '') + '</h4><ul class="zzv-ing unstyled-list">' + ingList(m) + '</ul></div>' +
          '<div><h4>Postup</h4><ol class="zzv-steps unstyled-list">' + m.postup.map(function (s) { return '<li><span>' + esc(s) + '</span></li>'; }).join('') + '</ol></div>' +
          (o2.noToggle ? '' : tgl(m)) + '</div>';
      }

      /* ---------- seznam ---------- */
      function rowHTML(it, o2) {
        o2 = o2 || {};
        var c = chk.has(it.ck), s = daysLabel(it.days);
        var innerH = '<span class="zzv-row__t"><span class="zzv-row__n">' + esc(it.name) + '</span>' + (o2.noDays ? '' : '<span class="zzv-row__s">' + esc(s) + '</span>') + '</span><span class="zzv-row__a">' + esc(it.amt) + '</span>';
        return '<li class="zzv-row' + (c ? ' is-done' : '') + '"><label class="zzv-row__l"><input type="checkbox" data-act="chk" data-k="' + esc(it.ck) + '"' + (c ? ' checked' : '') + '><span class="zzv-box">' + ic('check', 18) + '</span>' + innerH + '</label></li>';
      }
      var zShort = function (n) { return cap(n.replace(/\s*ZENZENA\s*/i, ' ').trim()); };
      function zenRow(z) {
        var k = z.ck, c = chk.has(k);
        var img = z.handle && IMG[z.handle];
        var h = z.handle || (z.cand.length === 1 ? z.cand[0] : null);
        var alt = !z.handle && z.cand.length > 1;
        var sub = z.n + ' ks · ' + daysLabel(z.days) + (!z.handle && z.cand.length === 1 ? ' · nejbližší: ' + (CAND[z.cand[0]] || '') : '');
        var thumb = img ? '<img class="zzv-thumb" src="' + esc(img) + '" alt="" width="44" height="44" loading="lazy">' : '<span class="zzv-thumb zzv-thumb--e">' + ic('leaf', 22) + '</span>';
        return '<li class="zzv-row zzv-zr' + (c ? ' is-done' : '') + '"><label class="zzv-row__l"><input type="checkbox" data-act="chk" data-k="' + esc(k) + '"' + (c ? ' checked' : '') + '><span class="zzv-box">' + ic('check', 18) + '</span>' + thumb + '<span class="zzv-row__t"><span class="zzv-row__n">' + esc(zShort(z.name)) + '</span><span class="zzv-row__s">' + esc(sub) + '</span></span></label>' +
          (h ? '<a class="zzv-btn zzv-btn--sec zzv-btn--sm zzv-zr__go" href="' + SHOP + '/products/' + h + '" target="_blank" rel="noopener" aria-label="Koupit: ' + esc(z.name) + '">Koupit</a>' : '') +
          (alt ? '<div class="zzv-zr__alt"><span>Vyberte příchuť:</span>' + z.cand.map(function (cc) { return '<a href="' + SHOP + '/products/' + cc + '" target="_blank" rel="noopener">' + esc(CAND[cc] || cc) + '</a>'; }).join('') + '</div>' : '') + '</li>';
      }
      /* Produkty ZENZENA: sbalený blok (nevnucuje se), rozbalí se klepnutím */
      function zenBlock(L, big) {
        if (!L.zen.length) return '';
        return '<section class="zzv-zen"><h3 class="zzv-zen__hh"><button type="button" class="zzv-zen__h" data-act="zen" aria-expanded="' + (ui.zenOpen ? 'true' : 'false') + '">' + ic('box', big ? 22 : 20) + '<span>' + esc(T.zenTitle) + ' <span class="n">(' + L.zen.length + ')</span></span><span class="zzv-zen__chev">' + ic(ui.zenOpen ? 'up' : 'down', 20) + '</span></button></h3>' +
          (ui.zenOpen ? '<p class="zzv-zen__s">' + esc(T.zenText) + '</p><ul class="zzv-rows unstyled-list">' + L.zen.map(zenRow).join('') + '</ul>' : '') + '</section>';
      }
      function homeBlock(L) {
        if (!L.home.length) return '';
        return '<section class="zzv-home"><h3>' + esc(T.homeTitle) + '</h3><ul class="unstyled-list">' + L.home.map(function (h) {
          return '<li>' + ic('check', 16) + '<span><b>' + esc(h.name) + '</b>' + (h.amt ? ' ' + esc(h.amt) : '') + ' · ze dne ' + h.den + (h.warn ? ' <span class="w">(jídlo ze dne ' + h.den + ' nemáte ve výběru, dokupte podle receptu)</span>' : '') + '</span></li>';
        }).join('') + '</ul></section>';
      }
      function listBody(L) {
        if (!L.count && !L.home.length) return '';
        var h = L.cats.map(function (c) {
          return '<section class="zzv-grp"><h3 class="zzv-grp__h">' + ic(c.ico, 20) + esc(c.label) + '<span class="n">' + c.items.length + '</span></h3><ul class="zzv-rows unstyled-list">' + c.items.map(function (i) { return rowHTML(i); }).join('') + '</ul></section>';
        }).join('');
        h += zenBlock(L);
        h += homeBlock(L);
        return h;
      }
      function actionsHTML(L) {
        var dis = L.count ? '' : ' disabled';
        return '<button type="button" class="zzv-btn zzv-btn--lg zzv-btn--block" data-act="shopgo"' + dis + '>' + ic('basket', 24) + 'Jdu nakupovat</button>' +
          '<div class="zzv-export"><h3 class="zzv-export__h">Uložit seznam do telefonu</h3>' +
          '<button type="button" class="zzv-btn zzv-btn--sec zzv-btn--block" data-act="share"' + dis + '>' + ic('share', 22) + 'Poslat do Poznámek</button>' +
          '<p class="zzv-export__how">' + esc(T.shareHint) + '</p>' +
          '<div class="zzv-export__row"><button type="button" class="zzv-link" data-act="copy"' + dis + '>Zkopírovat seznam</button><button type="button" class="zzv-link" data-act="txt"' + dis + '>Stáhnout .txt</button></div></div>';
      }
      function emptyHTML() {
        return '<div class="zzv-empty">' + ic('list', 34) + '<b>Seznam je zatím prázdný</b><span>Vyberte, co budete vařit, a suroviny se tu samy sečtou.</span></div>';
      }
      function listPanel(o2) {
        o2 = o2 || {};
        var L = buildList(sel);
        var head = o2.title ? '<h2 class="zzv-lp__h">' + esc(T.listTitle) + '</h2>' : '';
        var sub = '<p class="zzv-lp__s">' + (L.count ? nItems(L.count) + (L.done ? ' · ' + L.done + ' hotovo' : '') + ' · pro ' + esc(personsText()) + ' · ' + esc(selSummary()) : 'Zatím nic nevybíráte.') + '</p>';
        var unchk = L.done ? '<div class="zzv-unchk"><button type="button" class="zzv-link" data-act="unchk">Smazat odškrtnutí (' + L.done + ')</button></div>' : '';
        return head + sub + actionsHTML(L) + unchk + (L.count ? listBody(L) : emptyHTML() + homeBlock(L));
      }

      /* ---------- krok 1: co budete vařit ---------- */
      function dayChips() {
        return '<div class="zzv-days" role="group" aria-label="Dny výzvy">' + DAYS.map(function (d) {
          var s = dayState(d);
          return '<button type="button" class="zzv-chip" data-act="day" data-d="' + d + '" data-s="' + s + '" aria-pressed="' + (s === 2 ? 'true' : s === 1 ? 'mixed' : 'false') + '" aria-label="Den ' + d + ', ' + (s === 2 ? 'vybrán celý' : s === 1 ? 'vybrán částečně' : 'nevybrán') + '">' + (s === 2 ? ic('check', 16) : '') + d + '</button>';
        }).join('') + '</div>';
      }
      function typeChips() {
        return '<div class="zzv-chips" role="group" aria-label="Typy jídel">' + GRP.map(function (g) {
          var s = typeState(g.id);
          return '<button type="button" class="zzv-chip zzv-chip--wide" data-act="type" data-t="' + g.id + '" data-s="' + s + '" aria-pressed="' + (s === 2 ? 'true' : s === 1 ? 'mixed' : 'false') + '">' + (s === 2 ? ic('check', 16) : '') + g.chip + '</button>';
        }).join('') + '</div>';
      }
      function blocksRow() {
        return '<div class="zzv-blocks" role="group" aria-label="Rychlý výběr bloků dnů">' + [[1, 4], [5, 8], [9, 11]].map(function (p) {
          return '<button type="button" class="zzv-chip zzv-chip--wide" data-act="block" data-a="' + p[0] + '" data-b="' + p[1] + '">Dny ' + p[0] + '–' + p[1] + '</button>';
        }).join('') + '</div>';
      }
      function selLine() {
        return '<p class="zzv-sel"><span>' + (sel.size ? 'Vybráno: <b>' + esc(selSummary()) + '</b>' : 'Zatím nic nevybráno.') + '</span>' + (sel.size ? '<button type="button" class="zzv-link" data-act="clear">Zrušit výběr</button>' : '') + '</p>';
      }
      function pick(act, label, pressed, extra) {
        return '<button type="button" class="zzv-pick" data-act="' + act + '"' + (extra || '') + ' aria-pressed="' + pressed + '"><span class="zzv-pick__t">' + label + '</span><span class="zzv-pick__c" aria-hidden="true">' + (pressed ? ic('check', 20) : '') + '</span></button>';
      }
      function step1() {
        var all = allSelected();
        var panel = '';
        if (ui.panel === 'dny') panel = '<div class="zzv-panel"><p class="zzv-hint">' + esc(T.hintDny) + '</p>' + dayChips() + blocksRow() + '</div>';
        else if (ui.panel === 'jidla') panel = '<div class="zzv-panel"><p class="zzv-hint">' + esc(T.hintJidla) + '</p></div>';
        var adv = '<button type="button" class="zzv-adv__b" data-act="adv" aria-expanded="' + (ui.adv ? 'true' : 'false') + '" aria-controls="zzv-adv"><span>Upřesnit výběr</span>' + ic(ui.adv ? 'up' : 'down', 20) + '</button>' +
          (ui.adv ? '<div class="zzv-adv" id="zzv-adv"><p class="zzv-adv__h">Podle typu jídla</p>' + typeChips() +
            '<label class="zzv-switch"><input type="checkbox" data-act="nozen"' + (noZen ? ' checked' : '') + '><span class="zzv-switch__k" aria-hidden="true"></span><span class="zzv-switch__t">Jen jídla bez ZENZENA</span></label></div>' : '');
        return '<section class="zzv-step"><h2 class="zzv-step__h"><span class="zzv-step__n" aria-hidden="true">1</span>' + esc(T.step1) + '</h2>' +
          '<div class="zzv-choose" role="group" aria-label="' + esc(T.step1) + '">' +
          pick('all', 'Celá výzva', all) + pick('panel', 'Vybrat dny', ui.panel === 'dny', ' data-t="dny"') + pick('panel', 'Vybrat jídla', ui.panel === 'jidla', ' data-t="jidla"') +
          '</div>' + panel + selLine() + adv + '</section>';
      }
      function step2() {
        return '<section class="zzv-step"><h2 class="zzv-step__h"><span class="zzv-step__n" aria-hidden="true">2</span>' + esc(T.step2) + '</h2>' +
          '<div class="zzv-stepper" role="group" aria-label="Počet osob">' +
          '<button type="button" class="zzv-stepper__b" data-act="pm" data-v="-1" aria-label="Méně osob"' + (persons <= 1 ? ' disabled' : '') + '>' + ic('minus', 24) + '</button>' +
          '<output class="zzv-stepper__v" aria-live="polite"><b>' + persons + '</b> ' + pl(persons, 'osoba', 'osoby', 'osob') + '</output>' +
          '<button type="button" class="zzv-stepper__b" data-act="pm" data-v="1" aria-label="Více osob"' + (persons >= 6 ? ' disabled' : '') + '>' + ic('plus', 24) + '</button></div></section>';
      }
      function step3() {
        var L = buildList(sel);
        return '<section class="zzv-step zzv-step--list"><h2 class="zzv-step__h"><span class="zzv-step__n" aria-hidden="true">3</span>' + esc(T.step3) + '</h2>' +
          '<button type="button" class="zzv-btn zzv-btn--lg zzv-btn--block" data-act="opensheet" aria-haspopup="dialog" aria-expanded="' + (ui.sheet && ui.sheet.t === 'list' ? 'true' : 'false') + '">' + ic('basket', 24) + '<span>' + esc(T.step3Btn) + '</span>' + (L.count ? '<span class="zzv-btn__n">' + L.count + '</span>' : '') + '</button></section>';
      }

      /* ---------- recepty po dnech (akordeon) ---------- */
      function recipes() {
        return '<section class="zzv-rec"><h2 class="zzv-rec__h">' + esc(T.recipes) + '</h2><p class="zzv-hint">' + esc(T.recipesHint) + '</p><div class="zzv-acc">' + DAYS.map(function (d) {
          var ms = mealsOf(d), open = ui.open.has(d), n = ms.filter(function (m) { return sel.has(m.id); }).length;
          return '<section class="zzv-day' + (n ? ' has-sel' : '') + '"><h3 class="zzv-day__hh"><button type="button" class="zzv-day__b" data-act="dayopen" data-d="' + d + '" aria-expanded="' + (open ? 'true' : 'false') + '" aria-controls="zzv-dp-' + d + '"><span class="zzv-day__t">Den ' + d + '</span><span class="zzv-day__s">' + nMeals(ms.length) + (n ? ' · v nákupu ' + n : '') + '</span><span class="zzv-day__chev">' + ic(open ? 'up' : 'down', 22) + '</span></button></h3>' +
            (open ? '<div class="zzv-day__p" id="zzv-dp-' + d + '">' + ms.map(card).join('') + '</div>' : '') + '</section>';
        }).join('') + '</div></section>';
      }

      function bar() {
        var L = buildList(sel);
        return '<div class="zzv-bar"><button type="button" class="zzv-bar__b" data-act="opensheet" data-empty="' + (L.count ? 0 : 1) + '" aria-haspopup="dialog" aria-expanded="' + (ui.sheet && ui.sheet.t === 'list' ? 'true' : 'false') + '">' + ic('basket', 26) + '<span class="t">Nákupní seznam' + (L.count ? '<b aria-label="' + nItems(L.count) + '">' + L.count + '</b>' : '') + '</span>' + ic('up', 22) + '</button></div>';
      }

      /* ---------- hlavní blok ---------- */
      function viewA() {
        return '<div class="zzv-aw__m zzv-main">' + step1() + step2() + step3() + recipes() + '</div>' +
          '<aside class="zzv-aw__s" aria-label="Nákupní seznam">' + listPanel({ title: true }) + '</aside>' + bar();
      }

      /* ---------- okna (listy) a režim nákupu ---------- */
      function footHTML(m) {
        return '<div style="display:flex;gap:8px">' + tgl(m) + '<button type="button" class="zzv-btn zzv-btn--sec" data-act="closesheet" style="flex:1">Zavřít</button></div>';
      }
      function sheetHTML() {
        var sh = ui.sheet; if (!sh) return '';
        var k = '', t = '', body = '', foot = '';
        if (sh.t === 'list') { t = T.listTitle; body = listPanel({ title: false }); }
        else if (sh.t === 'recipe') {
          var m = byId.get(sh.id); k = 'Den ' + m.den + ' · ' + TYP_LABEL[m.typ]; t = m.nazev;
          body = recipeBody(m, { noToggle: true });
          foot = footHTML(m);
        }
        return '<div class="zzv-ov__bg" data-act="closesheet"></div><section class="zzv-sheet' + (ui.fresh ? ' zzv-sheet--in' : '') + '" role="dialog" aria-modal="true" aria-label="' + esc(t) + '"><div class="zzv-sheet__g"></div><header class="zzv-sheet__h"><h2>' + (k ? '<span class="k">' + esc(k) + '</span>' : '') + esc(t) + '</h2><button type="button" class="zzv-x" data-act="closesheet" aria-label="Zavřít">' + ic('x', 22) + '</button></header><div class="zzv-sheet__b">' + body + '</div>' + (foot ? '<footer class="zzv-sheet__f">' + foot + '</footer>' : '') + '</section>';
      }
      function lock(on) {
        document.body.style.overflow = on ? 'hidden' : '';
        try { inner.inert = !!on; } catch (e) { /* starší prohlížeč */ }
      }
      function rememberFocus() { var a = document.activeElement; ui.lastFocus = a && a.dataset && a.dataset.act ? fkey(a) : null; }
      function restoreFocus() {
        var k = ui.lastFocus; ui.lastFocus = null;
        if (!k) return;
        var e = $$('[data-act]', app).filter(function (x) { return fkey(x) === k && !x.disabled; })[0];
        if (e) try { e.focus({ preventScroll: true }); } catch (_) { /* nic */ }
      }
      /* tlačítka seznamu (krok 3 i lišta dole) vědí, jestli je seznam otevřený (aria-expanded) */
      function syncBar() { $$('[data-act=opensheet]', app).forEach(function (b) { b.setAttribute('aria-expanded', ui.sheet && ui.sheet.t === 'list' ? 'true' : 'false'); }); }
      function openSheet(s) { rememberFocus(); ui.sheet = s; ui.fresh = true; lock(true); renderOv(); ui.fresh = false; syncBar(); var x = $('.zzv-x', ov); if (x) x.focus(); }
      function closeSheet(silent) {
        if (!ui.sheet) return;
        ui.sheet = null;
        if (!ui.shopping) lock(false);
        renderOv(); syncBar();
        if (!silent) restoreFocus();
      }
      function focusKey(c) { var a = document.activeElement; return a && c.contains(a) && a.dataset && a.dataset.act ? fkey(a) : null; }
      function focusBack(c, k) { if (!k) return; var e = $$('[data-act]', c).filter(function (x) { return fkey(x) === k && !x.disabled; })[0]; if (e) try { e.focus({ preventScroll: true }); } catch (_) { /* nic */ } }
      function renderOv(force) {
        var fk = focusKey(ov);
        var old = $('.zzv-sheet__b', ov), top = old ? old.scrollTop : 0, same = old && ui.sheet;
        if (!ui.sheet) { ov.classList.remove('is-open'); ov.innerHTML = ''; ov.removeAttribute('data-sig'); return; }
        /* Okno receptu už je otevřené a změnilo se jen „Do nákupu“: překreslí se jen patička. Celé
           okno by znovu vyrobilo iframe s Instagramem a video by začalo od začátku. */
        var sig = ui.sheet.t + ':' + (ui.sheet.id || '');
        var pat = $('.zzv-sheet__f', ov);
        if (!force && !ui.fresh && ui.sheet.t === 'recipe' && ov.getAttribute('data-sig') === sig && pat) {
          pat.innerHTML = footHTML(byId.get(ui.sheet.id));
          focusBack(ov, fk);
          return;
        }
        ov.setAttribute('data-sig', sig);
        ov.innerHTML = sheetHTML(); ov.classList.add('is-open');
        fixNbsp(ov);
        var nb = $('.zzv-sheet__b', ov); if (nb && same && !ui.fresh) nb.scrollTop = top;
        if (!ui.fresh) focusBack(ov, fk);
      }
      function renderShop() {
        var el = shopEl;
        if (!ui.shopping) { el.classList.remove('is-open'); el.innerHTML = ''; return; }
        var old = $('.zzv-shop__b', el), top = old ? old.scrollTop : 0; var fk = focusKey(el);
        var L = buildList(sel);
        var left = L.count - L.done, pct = L.count ? Math.round(L.done / L.count * 100) : 0;
        var undone = function (it) { return !chk.has(it.ck); };
        var catsU = L.cats.map(function (c) { return Object.assign({}, c, { items: c.items.filter(undone) }); }).filter(function (c) { return c.items.length; });
        var zU = L.zen.filter(function (z) { return !chk.has(z.ck); });
        var doneItems = [].concat.apply([], L.cats.map(function (c) { return c.items.filter(function (i) { return chk.has(i.ck); }); }));
        var doneZ = L.zen.filter(function (z) { return chk.has(z.ck); });
        var wl = '';
        if (ui.wl === 'on') wl = '<div class="zzv-wl zzv-wl--on" role="status"><span class="dot"></span><span>Displej zůstane rozsvícený</span></div>';
        else if (ui.wl === 'off') wl = '<div class="zzv-wl zzv-wl--off" role="status"><span class="dot"></span><span>Displej může zhasnout<small>Rozsvícení se uvolnilo (třeba po přepnutí do jiné aplikace).</small><button type="button" class="zzv-btn zzv-btn--sm zzv-btn--sec" data-act="wlagain">Znovu držet rozsvícené</button></span></div>';
        else if (ui.wl === 'unsupported' || ui.wl === 'denied') wl = '<div class="zzv-wl zzv-wl--off" role="status"><span class="dot"></span><span>Displej se může zhasnout<small>Tenhle prohlížeč neumí držet displej rozsvícený (iPhone to umí od iOS 16.4). Nastavte si dočasně delší automatický zámek displeje.</small></span></div>';
        var rowsU = (L.cats.length || L.zen.length) ? (catsU.map(function (c) { return '<section class="zzv-grp"><h3 class="zzv-grp__h">' + ic(c.ico, 22) + esc(c.label) + '<span class="n">' + c.items.length + '</span></h3><ul class="zzv-rows unstyled-list">' + c.items.map(function (i) { return rowHTML(i, { noDays: true }); }).join('') + '</ul></section>'; }).join('') + (zU.length ? zenBlock({ zen: zU }, true) : '')) : '';
        var fin = (L.count && !left) ? '<p class="zzv-fin">Máte hotovo. Dobrou chuť.</p>' : '';
        var doneBlock = (doneItems.length || doneZ.length) ? '<section class="zzv-grp zzv-donee"><h3 class="zzv-grp__h">' + ic('check', 22) + 'Hotovo<span class="n">' + (doneItems.length + doneZ.length) + '</span></h3><ul class="zzv-rows unstyled-list">' + doneZ.map(zenRow).join('') + doneItems.map(function (i) { return rowHTML(i, { noDays: true }); }).join('') + '</ul><div class="zzv-unchk"><button type="button" class="zzv-link" data-act="unchk">Smazat odškrtnutí</button></div></section>' : '';
        el.classList.add('is-open');
        el.innerHTML = '<header class="zzv-shop__h"><div><h2>Nakupuji</h2><p>' + (L.count ? (left ? 'Zbývá ' + left + ' z ' + L.count : 'Všech ' + L.count + ' hotovo') : 'Seznam je prázdný') + '</p></div><button type="button" class="zzv-btn zzv-btn--sec zzv-btn--sm" data-act="shopx">Hotovo</button></header><div class="zzv-prog" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + pct + '" aria-label="Postup nákupu"><i style="width:' + pct + '%"></i></div>' + wl + '<div class="zzv-shop__b">' + fin + rowsU + doneBlock + '</div>';
        fixNbsp(el);
        var nb = $('.zzv-shop__b', el); if (nb && old) nb.scrollTop = top;
        focusBack(el, fk);
      }

      /* ---------- vykreslení a události ---------- */
      function fkey(el) { var d = el.dataset; return d.act + '|' + (d.id || d.d || d.k || d.t || d.s || d.v || (d.a ? d.a + '-' + d.b : '')); }
      function renderPage() {
        var fa = document.activeElement && app.contains(document.activeElement) && document.activeElement.dataset && document.activeElement.dataset.act ? fkey(document.activeElement) : null;
        app.innerHTML = viewA();
        fixNbsp(app);
        if (fa) { var e = $$('[data-act]', app).filter(function (x) { return fkey(x) === fa && !x.disabled; })[0]; if (e) try { e.focus({ preventScroll: true }); } catch (_) { /* nic */ } }
        app.setAttribute('data-ready', '1');
      }
      function update() { persist(); renderPage(); renderOv(); if (ui.shopping) renderShop(); }

      root.addEventListener('click', function (e) {
        var t = e.target.closest('[data-act]'); if (!t || t.matches('input')) return;
        var a = t.dataset.act, id = t.dataset.id, d = +t.dataset.d;
        switch (a) {
          case 'panel':
            ui.panel = ui.panel === t.dataset.t ? null : t.dataset.t;
            if (ui.panel === 'jidla') ui.open.add(DAYS[0]);
            update();
            if (ui.panel === 'jidla') { var r = $('.zzv-rec', app); if (r && r.scrollIntoView) r.scrollIntoView({ block: 'start' }); }
            return;
          case 'adv': ui.adv = !ui.adv; return update();
          case 'day': toggleDay(d); return update();
          case 'type': toggleType(t.dataset.t); return update();
          case 'block': setDays(Array.from({ length: +t.dataset.b - +t.dataset.a + 1 }, function (_, i) { return +t.dataset.a + i; })); return update();
          case 'all': toggleAll(); return update();
          case 'clear': sel.clear(); chk.clear(); return update();
          case 'unchk': chk.clear(); toast('Odškrtnutí je smazané.'); return update();
          case 'pm': persons = Math.max(1, Math.min(6, persons + (+t.dataset.v))); return update();
          case 'dayopen': if (ui.open.has(d)) ui.open.delete(d); else ui.open.add(d); return update();
          case 'zen': ui.zenOpen = !ui.zenOpen; return update();
          case 'recipe': return openSheet({ t: 'recipe', id: id });
          case 'opensheet': return openSheet({ t: 'list' });
          case 'closesheet': return closeSheet();
          case 'vid': ui.vid.add(id); renderOv(true); return;
          case 'shopgo': return startShopping();
          case 'shopx': return stopShopping();
          case 'wlagain': return wlOn().then(renderShop);
          case 'share': return doShare();
          case 'copy': return doCopy(exportText(), 'Seznam je zkopírovaný.');
          case 'txt': return doDownload();
        }
      });
      root.addEventListener('change', function (e) {
        var t = e.target.closest('input[data-act]'); if (!t) return;
        var a = t.dataset.act;
        if (a === 'meal') { var id = t.dataset.id; var m = byId.get(id); if (!canSel(m)) return update(); if (t.checked) sel.add(id); else sel.delete(id); return update(); }
        if (a === 'nozen') { noZen = t.checked; if (noZen) DATA.forEach(function (m) { if (!canSel(m)) sel.delete(m.id); }); return update(); }
        if (a === 'chk') { var k = t.dataset.k; if (t.checked) chk.add(k); else chk.delete(k); return update(); }
      });
      document.addEventListener('keydown', function (e) {
        if (!root.isConnected) return;
        if (e.key === 'Escape') { if (ui.shopping) return stopShopping(); if (ui.sheet) return closeSheet(); }
        if (e.key === 'Tab' && (ui.sheet || ui.shopping)) {
          /* focus se v otevřeném okně nesmí ztratit za ním */
          var box = ui.shopping ? shopEl : $('.zzv-sheet', ov); if (!box) return;
          var f = $$('a[href],button:not([disabled]),input:not([disabled]),[tabindex]:not([tabindex="-1"])', box).filter(function (x) { return x.getClientRects().length; });
          if (!f.length) return;
          var first = f[0], last = f[f.length - 1], act = document.activeElement;
          if (!box.contains(act)) { e.preventDefault(); first.focus(); }
          else if (e.shiftKey && act === first) { e.preventDefault(); last.focus(); }
          else if (!e.shiftKey && act === last) { e.preventDefault(); first.focus(); }
        }
      });

      /* ---------- hotovo: první vykreslení ---------- */
      fixNbsp(root);
      update();
    }
  }

  /* ---------- hledání instancí; plánovač se spustí, až když akce neni „před startem“ ---------- */
  function scan() {
    $$('.zzv[data-zzv]').forEach(function (root) {
      if (root.getAttribute('data-zzv-on')) return;
      root.setAttribute('data-zzv-on', '1');
      var pred = function () { return html.classList.contains('zz-akce--pred'); };
      if (!pred()) { boot(root); return; }
      var mo = new MutationObserver(function () {
        if (pred()) return;
        mo.disconnect();
        boot(root);
      });
      mo.observe(html, { attributes: true, attributeFilter: ['class'] });
    });
  }
  window.__zzvScan = scan;
  scan();
  document.addEventListener('shopify:section:load', scan);
})();
